define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable",
	"Apparel/StructureItemShapeMixin"
], function(declare,StructureItemTable,StructureItemShapeMixin) {

    return declare([StructureItemTable,StructureItemShapeMixin],{

	});
});